



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { ITrackCount } from '@/store/modules/discovery'
import { combineArtistTitle } from '@/helpers/track'

@Component({
  components: {
    GlobalWaveform: require('@/components/GlobalWaveform').default
  }
})
export default class DiscoveryResultItem extends Vue {
  @Prop({
    required: true
  })
  data: ITrackCount

  @Prop({
    required: true
  })
  hotCount: number

  get spotifyUrl(): string {
    return `spotify://${this.data.track.url}`
  }

  get name(): string {
    return combineArtistTitle(this.data.track.artist, this.data.track.title)
  }

  get selected(): boolean {
    return this.$store.state.discovery.selectedIds.includes(this.data.id)
  }

  toggleSelected(e: MouseEvent) {
    this.$store.commit('discovery/toggleSelectedById', this.data.id)

    e.stopPropagation()
    e.preventDefault()
  }
}
